import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { AlertService } from './alert.service';
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';
import { AppUrl } from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class RolePermissionService extends BaseService {
  constructor(
    public http: HttpClient,
    public alertService: AlertService,
    public globalService: GlobalService
  ) {
    super(http, alertService, globalService);
  }

  add(data): Observable<any> {
    return this.postRequest(AppUrl.ROLE_PERMISSIONS(), data);
  }

  update(unique_id, data): Observable<any> {
    return this.putRequest(AppUrl.ROLE_PERMISSIONS(unique_id), data);
  }

  get(data): Observable<any> {
    return this.getRequest(AppUrl.ROLE_PERMISSIONS(), data);
  }

  detail(unique_id): Observable<any> {
    return this.getRequest(AppUrl.ROLE_PERMISSIONS(unique_id));
  }

  status(unique_id, data): Observable<any> {
    return this.putRequest(AppUrl.ROLE_PERMISSIONS_STATUS(unique_id), data);
  }

  delete(uniqueId: any): Observable<any> {
    return this.deleteRequest(AppUrl.ROLE_PERMISSIONS(uniqueId));
  }

  deleteAllByRole(uniqueId: any): Observable<any> {
    return this.deleteRequest(AppUrl.DELETE_ALL_ROLE_PERMISSIONS(uniqueId));
  }
}
